import { fetchQuery } from '@/services/messaging/fetchQuery';

export function getDepartmentColleagues() {
  return fetchQuery("GetDepartmentColleagues", {});
}
